/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_TaskManagerConsoleListDto } from '../models/PagedResultDto_TaskManagerConsoleListDto';
import type { Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_GetTaskFileStatusByTaskIdDto } from '../models/Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_GetTaskFileStatusByTaskIdDto';
import type { Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_TaskDetailStatusByIdResponseDto } from '../models/Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_TaskDetailStatusByIdResponseDto';
import type { Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_TaskManagerConsoleByIdResultDto } from '../models/Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_TaskManagerConsoleByIdResultDto';
import type { Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_TaskManagerConsoleListResultDto } from '../models/Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_TaskManagerConsoleListResultDto';
import type { Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_TaskManagerConsoleResponseDto } from '../models/Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_TaskManagerConsoleResponseDto';
import type { Wealthlane_TaskManagerService_Dtos_TaxItem_TaxItemFileResultDto } from '../models/Wealthlane_TaskManagerService_Dtos_TaxItem_TaxItemFileResultDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TaskManagerConsoleService {

    /**
     * @param fromCreatedDate 
     * @param toCreatedDate 
     * @param taskTypeId 
     * @param statusId 
     * @param createdById 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_TaskManagerConsoleListDto OK
     * @throws ApiError
     */
    public static getApiTaskmanagerApiAppTaskManagerConsoleTaskManagerConsoleList(
fromCreatedDate?: string,
toCreatedDate?: string,
taskTypeId?: Array<string>,
statusId?: Array<string>,
createdById?: Array<string>,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_TaskManagerConsoleListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/taskmanager/api/app/task-manager-console/task-manager-console-list',
            query: {
                'FromCreatedDate': fromCreatedDate,
                'ToCreatedDate': toCreatedDate,
                'TaskTypeId': taskTypeId,
                'StatusId': statusId,
                'CreatedById': createdById,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_TaskManagerConsoleByIdResultDto OK
     * @throws ApiError
     */
    public static getApiTaskmanagerApiAppTaskManagerConsoleTaskManagerConsoleById(
id: string,
): CancelablePromise<Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_TaskManagerConsoleByIdResultDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/taskmanager/api/app/task-manager-console/{id}/task-manager-console-by-id',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_TaskDetailStatusByIdResponseDto OK
     * @throws ApiError
     */
    public static getApiTaskmanagerApiAppTaskManagerConsoleTaskDetailStatusById(
id: string,
): CancelablePromise<Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_TaskDetailStatusByIdResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/taskmanager/api/app/task-manager-console/{id}/task-detail-status-by-id',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_TaskManagerConsoleListResultDto OK
     * @throws ApiError
     */
    public static getApiTaskmanagerApiAppTaskManagerConsoleExecutedReportList(): CancelablePromise<Array<Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_TaskManagerConsoleListResultDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/taskmanager/api/app/task-manager-console/executed-report-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param taskId 
     * @returns Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_GetTaskFileStatusByTaskIdDto OK
     * @throws ApiError
     */
    public static getApiTaskmanagerApiAppTaskManagerConsoleTaskFileStatusByTaskId(
taskId: string,
): CancelablePromise<Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_GetTaskFileStatusByTaskIdDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/taskmanager/api/app/task-manager-console/task-file-status-by-task-id/{TaskId}',
            path: {
                'TaskId': taskId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getApiTaskmanagerApiAppTaskManagerConsoleGrantedJobPermissionList(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/taskmanager/api/app/task-manager-console/granted-job-permission-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_TaskManagerConsoleResponseDto OK
     * @throws ApiError
     */
    public static deleteApiTaskmanagerApiAppTaskManagerConsoleJob(
id: string,
): CancelablePromise<Wealthlane_TaskManagerService_Dtos_TaskManagerConsole_TaskManagerConsoleResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/taskmanager/api/app/task-manager-console/{id}/job',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param taskId 
     * @returns Wealthlane_TaskManagerService_Dtos_TaxItem_TaxItemFileResultDto OK
     * @throws ApiError
     */
    public static getApiTaskmanagerApiAppTaskManagerConsoleUploadedFile(
taskId: string,
): CancelablePromise<Array<Wealthlane_TaskManagerService_Dtos_TaxItem_TaxItemFileResultDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/taskmanager/api/app/task-manager-console/uploaded-file/{taskId}',
            path: {
                'taskId': taskId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
